export default __webpack_public_path__ + "static/media/line-v-02.bd74b190.png";